enum SystemInfoActionsTypes {
  CREATE_SYSTEM_INFO_IN_PROGRESS = 'CREATE_SYSTEM_INFO_IN_PROGRESS',
  CREATE_SYSTEM_INFO_SUCCESS = 'CREATE_SYSTEM_INFO_SUCCESS',
  CREATE_SYSTEM_INFO_ERROR = 'CREATE_SYSTEM_INFO_ERROR',

  LIST_SYSTEM_INFO_IN_PROGRESS = 'LIST_SYSTEM_INFO_IN_PROGRESS',
  LIST_SYSTEM_INFO_SUCCESS = 'LIST_SYSTEM_INFO_SUCCESS',
  LIST_SYSTEM_INFO_ERROR = 'LIST_SYSTEM_INFO_ERROR',

  VIEW_SYSTEM_INFO_IN_PROGRESS = 'VIEW_SYSTEM_INFO_IN_PROGRESS',
  VIEW_SYSTEM_INFO_SUCCESS = 'VIEW_SYSTEM_INFO_SUCCESS',
  VIEW_SYSTEM_INFO_ERROR = 'VIEW_SYSTEM_INFO_ERROR',

  UPDATE_SYSTEM_INFO_IN_PROGRESS = 'UPDATE_SYSTEM_INFO_IN_PROGRESS',
  UPDATE_SYSTEM_INFO_SUCCESS = 'UPDATE_SYSTEM_INFO_SUCCESS',
  UPDATE_SYSTEM_INFO_ERROR = 'UPDATE_SYSTEM_INFO_ERROR',

  DELETE_SYSTEM_INFO_IN_PROGRESS = 'DELETE_SYSTEM_INFO_IN_PROGRESS',
  DELETE_SYSTEM_INFO_SUCCESS = 'DELETE_SYSTEM_INFO_SUCCESS',
  DELETE_SYSTEM_INFO_ERROR = 'DELETE_SYSTEM_INFO_ERROR',

  RESET_STATE = 'RESET_STATE'
}

export default SystemInfoActionsTypes;
